import { createSelector } from '@ngrx/store';
import { NotificationStoreModule } from './notification-store.module';
import { NotificationState, userType } from './notification.model';

export const selectItems = (state: NotificationStoreModule) => (state.Notification ? state.Notification : null);

export const getLoader = () =>
  createSelector(selectItems, (items) => {
    if (items['loader']) {
      return true;
    } else {
      return false;
    }
  });
export const getreverseLoader = () =>
  createSelector(selectItems, (items) => {
    if (items['loader']) {
      return false;
    } else {
      return true;
    }
  });

const groupBy = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

export const getProfessionalNotification = () =>
  createSelector(selectItems, (items) => {
    {
      if (items?.notifications?.length) {
        let tfilterData = items?.notifications.filter(
          (x) => !x.origin || x.origin?.toLowerCase() == 'workspace' || x.origin?.toLowerCase() == 'vault'
        );
        tfilterData = tfilterData.filter((x) => x.is_read == false);
        let filterData = [];
        tfilterData.forEach((element) => {
          var objectA = {
            showNotes_fe: true,
          };
          var objectC = { ...objectA, ...element };
          if (element.origin && (element.origin.toLowerCase() == 'workspace' || element.origin.toLowerCase() == 'vault')) {
            filterData.push(objectC);
          } else {
            if (
              element?.notification.default_origin &&
              (element?.notification.default_origin.toLowerCase() == 'workspace' || element?.notification.default_origin.toLowerCase() == 'vault')
            ) {
              filterData.push(objectC);
            }
          }
        });
        const personGroupedByColor = groupBy(filterData, 'from_user_id');

        var resultArray = Object.keys(personGroupedByColor).map(function (personNamedIndex) {
          let person = personGroupedByColor[personNamedIndex];
          person.from_user_id = personGroupedByColor[personNamedIndex][0].from_user_id;
          person.showTask = true;
          person.showMore = true;
          let max = 0;
          personGroupedByColor[personNamedIndex].forEach((character) => {
            if (character.id > max) {
              max = character.id;
            }
          });
          person.max = max;
          // do something with person
          return person;
        });
        let sortedCountries = resultArray.sort((first, second) => 0 - (first.max < second.max ? -1 : 1));
        return sortedCountries;
      } else {
        return [];
      }
    }
  });

export const getAcceptedNotifications = (calledAt: string) =>
  createSelector(selectItems, (items) => {
    if (items != null && items?.notifications?.length) {
      let notification;
      if (calledAt == 'home') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Accepted && !notification.is_read && notification.message_data
            ? notification
            : null;
        });
      } else if (calledAt == 'personal' || calledAt == 'office-clients') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Accepted &&
            !notification.is_read &&
            notification.message_data &&
            (notification?.message_data?.user_type == '' || notification?.message_data?.user_type == null)
            ? notification
            : null;
        });
      } else if (calledAt == 'professional' || calledAt == 'office-professional') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Accepted &&
            !notification.is_read &&
            notification.message_data &&
            notification?.message_data?.user_type == userType.Professional
            ? notification
            : null;
        });
      }

      return notification;
    }
  });

export const getDeclinedNotifications = (calledAt: string) =>
  createSelector(selectItems, (items) => {
    if (items != null && items?.notifications?.length) {
      let notification;
      if (calledAt == 'home') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Declined && !notification.is_read && notification.message_data
            ? notification
            : null;
        });
      } else if (calledAt == 'personal' || calledAt == 'office-clients') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Declined &&
            !notification.is_read &&
            notification.message_data &&
            (notification?.message_data?.user_type == '' || notification?.message_data?.user_type == null)
            ? notification
            : null;
        });
      } else if (calledAt == 'professional' || calledAt == 'office-professional') {
        notification = items?.notifications.filter((notification) => {
          return notification.notification_id == NotificationState.Declined &&
            !notification.is_read &&
            notification.message_data &&
            notification?.message_data?.user_type == userType.Professional
            ? notification
            : null;
        });
      }

      return notification;
    }
  });

  /** 
   * Method to get accepted and declined notifications
   */
  
